import {BusEventEnum, EventBus} from '@core/eventBus';

/**
 * Emits a user interaction event for use with `useSkipUserInteractionUpdateEffect`.
 */
export const emitUserInteractionEvent = () => {
    EventBus.send({key: BusEventEnum.USER_INTERACTION});
};
